import { PairsV4 } from '@ui/services/contract/hooks/PairsManagerFacet/usePairsV4';

export const getProperLeverageMargin = (
  leverageMargins: PairsV4['leverageMargins'],
  leverage: number,
) => {
  if (!Array.isArray(leverageMargins) || leverageMargins.length === 0) {
    return undefined;
  }

  if (!Number.isFinite(leverage)) {
    return undefined;
  }

  // Avoid mutating the original array; sort a shallow copy
  const sortedByMaxLeverage = [...leverageMargins].sort(
    (a, b) => a.maxLeverage - b.maxLeverage,
  );

  const matched = sortedByMaxLeverage.find(
    (margin) => leverage <= margin.maxLeverage,
  );

  // If leverage exceeds all tiers, fallback to the highest tier
  return matched ?? sortedByMaxLeverage[sortedByMaxLeverage.length - 1];
};
